import { FormControl } from '@angular/forms';
import { Directive, AfterViewInit, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[prevent-space]'
})
export class PreventSpaceDirective implements AfterViewInit{

  constructor(private el: ElementRef) { }
  ngAfterViewInit(){
      let self=this;
      this.el.nativeElement.addEventListener('keydown', this.checkChanges.bind(this, self.el))
      
  }
  
  checkChanges(el, event){
    var val = el.nativeElement.value;
    if(event.code == 'Space'){
      if(val.length == 0 || val[val.length-1]==' '){
        event.preventDefault();
      }
    }
  }
}